import {Injectable} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {AngularFireAuth} from 'angularfire2/auth'
import {environment} from 'environments/environment'
import * as firebase from 'firebase/app'
import * as SparkMD5 from 'spark-md5'

@Injectable()
export class UploadService {
  constructor(private auth: AngularFireAuth) {}

  async upload(allFiles, project, options) {
    let filesGroupedPerCreative = await this.sortItems(allFiles)
    filesGroupedPerCreative = this.flattenEntriesExceptHTML(filesGroupedPerCreative)
    filesGroupedPerCreative = filesGroupedPerCreative.map(item => (Array.isArray(item) ? item : [item]))

    for (let i in filesGroupedPerCreative) {
      // console.log(filesGroupedPerCreative[i])
      const files = filesGroupedPerCreative[i]
      const creative = {
        name: files[0].name,
        files: files.map(file => file.name),
        path: files[0].fullPath.split('/').slice(0, -2).join('/'),
      }
      let dest = null
      if (files.length > 1) {
        creative.name = files[0].fullPath.split('/').slice(0, -1).reverse()[0]
        dest = files[0].fullPath.split('/').reverse()[1]
      }
      await Promise.all(files.map(file => this.uploadFile(file, project, dest))).then(res => {
        this.triggerCloudFunction(creative, project, options)
      })
    }
  }

  triggerCloudFunction(creative, project, options) {
    options.creatives = [creative]
    options.user = {
      uid: this.auth.auth.currentUser.uid,
      email: this.auth.auth.currentUser.email,
      displayName: this.auth.auth.currentUser.displayName,
      photoURL: this.auth.auth.currentUser.photoURL,
    }
    const url =
      window.location.hostname == 'localhost'
        ? `http://localhost:5001/${environment.firebase.storageBucket.split('.')[0]}/us-central1/syncStorage`
        : `https://us-central1-${environment.firebase.storageBucket.split('.')[0]}.cloudfunctions.net/syncStorage`
    return fetch(`${url}?projectId=${project.id}`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(options),
    })
    // const url = window.location.hostname == 'localhost' ? `http://localhost:5001/${environment.firebase.storageBucket.split('.')[0]}/us-central1/syncCreative` : `https://us-central1-${environment.firebase.storageBucket.split('.')[0]}.cloudfunctions.net/syncCreative`
    // return fetch(`${url}?projectId=${project.id}`, {
    //   method: 'POST',
    //   mode: 'cors',
    //   body: JSON.stringify(options),
    // })
  }

  sortItems(items) {
    let entries = []
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry()
      if (entry) {
        if (entry.isFile) {
          entries.push(new Promise((resolve, reject) => resolve(entry)))
        } else if (entry.isDirectory) {
          entries.push(UploadService.traverseDirectory(entry))
        }
      }
    }
    return Promise.all(entries)
  }

  flattenEntriesExceptHTML(arr, result = []) {
    for (let i = 0, length = arr.length; i < length; i++) {
      const value = arr[i]
      if (Array.isArray(value)) {
        if (value.some(entry => entry.name == 'index.html')) result.push(value)
        else this.flattenEntriesExceptHTML(value, result)
      } else {
        result.push(value)
      }
    }
    return result
  }

  static isIgnoredFile(file) {
    if (file.name == '.DS_Store') return true
    return false
  }

  // https://stackoverflow.com/questions/18815197/javascript-file-dropping-and-reading-directories-asynchronous-recursion
  static traverseDirectory(entry) {
    const _ = this
    const reader = entry.createReader()
    return new Promise((resolve, reject) => {
      const iterationAttempts = []
      function readEntries() {
        reader.readEntries(
          entries => {
            if (!entries.length) {
              resolve(Promise.all(iterationAttempts))
            } else {
              iterationAttempts.push(
                Promise.all(
                  entries
                    .filter(ientry => !UploadService.isIgnoredFile(ientry))
                    .map(ientry => {
                      if (ientry.isFile) {
                        return ientry
                      }
                      return UploadService.traverseDirectory(ientry)
                    })
                )
              )
              readEntries()
            }
          },
          error => reject(error)
        )
      }
      readEntries()
    })
  }

  uploadFile(entry, project, dest = null) {
    if (UploadService.isIgnoredFile(entry)) return
    return new Promise((resolve, reject) => {
      entry.file(file => {
        this.md5(file).then(md5 => {
          console.log(['projects', project.id, dest, file.name].join('/'))
          const uploadTask = firebase.storage().ref(['projects', project.id, dest, file.name].join('/')).put(file, {
            md5Hash: md5,
          })
          uploadTask.on(
            'state_changed',
            snapshot => {
              const progress = (snapshot['bytesTransferred'] / snapshot['totalBytes']) * 100
              // _.loader.update('Uploading files...', snapshot['bytesTransferred'] / snapshot['totalBytes'])
            },
            error => {
              if (error['code'] == 'storage/unauthorized') {
                console.log(file.name + ' already exists, skip it')
                resolve()
              }
            },
            () => resolve(uploadTask)
          )
        })
      })
    })
  }

  md5(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const chunkSize = 2097152
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()
      let cursor = 0
      fileReader.onerror = function (): void {
        reject('MD5 computation failed - error reading the file')
      }
      function processChunk(chunk_start: number): void {
        const chunk_end = Math.min(file.size, chunk_start + chunkSize)
        fileReader.readAsArrayBuffer(file.slice(chunk_start, chunk_end))
      }
      fileReader.onload = function (e: any): void {
        spark.append(e.target.result)
        cursor += chunkSize

        if (cursor < file.size) processChunk(cursor)
        else resolve(btoa(spark.end(true)))
      }

      processChunk(0)
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-upload/upload.service.ts